import { CampaignStatsComponent } from './campaign-stats.component';

export default angular
  .module('sfMobile.components.campaign-stats', ['sfMobile.services.forms'])
  .component('sfCampaignStats', CampaignStatsComponent).name;
